import React from 'react';
import About from '../About/About';
import FirstSection from '../FirstSection/FirstSection';
import Header from '../Header/Header';
import Projects from '../Projects/Projects';
import Contact from '../Contact/Contact';
import './Home.css';
import Footer from '../Footer/Footer';

const Home = () => {
   return (
      <div className='main'>
         <Header></Header>
         <FirstSection></FirstSection>
         <About></About>
         <Projects></Projects>
         <Contact></Contact>
         <Footer></Footer>
      </div>
   );
};

export default Home;